import { render, staticRenderFns } from "./edit-partner-pricing.vue?vue&type=template&id=a404987c&scoped=true&"
import script from "./edit-partner-pricing.vue?vue&type=script&lang=js&"
export * from "./edit-partner-pricing.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner-pricing.vue?vue&type=style&index=0&id=a404987c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a404987c",
  null
  
)

export default component.exports